import { styled } from "@mui/material";
import { FormDurationInput } from "form";
import { useTranslation } from "react-i18next";

const FormDurationInputStyled = styled(FormDurationInput)({
  marginTop: "8px",
  width: "150px",
});

const WateringDurationInput = ({ isViewMode }) => {
  const { t } = useTranslation();

  return (
    <FormDurationInputStyled
      name="timeTaken"
      placeholder={t("DurationInput.Label") + "*"}
      shouldHaveErrorBehaviorAfterSubmit
      isViewMode={isViewMode}
      units={t("DurationInput.Minutes")}
    />
  );
};

export default WateringDurationInput;
